export default __webpack_public_path__ + "static/media/013-deer.7576a863.svg";